import React from 'react'
import { IconStyles } from './RecommendationCarousel.types'

export const DefaultLeftIcon = ({
  fill,
  stroke,
  strokeWidth,
  width
}: IconStyles) => (
  <svg
    fill={fill}
    stroke={stroke}
    strokeWidth={strokeWidth}
    width={width}
    height={width}
    version='1.1'
    id='Ebene_1'
    x='0px'
    y='0px'
    viewBox='0 0 141.73 141.73'
  >
    <g>
      <polygon points='90.26,112.3 92.36,110.19 53.61,71.5 92.36,32.81 90.26,30.7 49.38,71.5' />
    </g>
  </svg>
)

export const DefaultRightIcon = ({
  fill,
  stroke,
  strokeWidth,
  width
}: IconStyles) => (
  <svg
    fill={fill}
    stroke={stroke}
    strokeWidth={strokeWidth}
    width={width}
    height={width}
    version='1.1'
    id='Ebene_1'
    x='0px'
    y='0px'
    viewBox='0 0 141.73 141.73'
  >
    <g>
      <polygon points='51.49,112.3 49.38,110.19 88.14,71.5 49.38,32.81 51.49,30.7 92.36,71.5' />
    </g>
  </svg>
)
